import { HIDE_CONFIRM, ON_CONFIRM, SHOW_CONFIRM } from "./actionType";

const initialState = {
    show: false,
    message: '',
    title: 'Confirm',
    confirm: () => {}
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

        case SHOW_CONFIRM:
            return {...state, show: true, message: payload.message, confirm: payload.onConfirm }
        case ON_CONFIRM:
            return {...state, show: false }
        case HIDE_CONFIRM:
            return {...state, show: false, message: '', confirm: () => {} }

        default:
            return state
    }
}